import React from 'react';
import RenderField from 'shared/dist/components/atoms/RenderField';
export default RenderField(React);
